
import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class PraticheService{
  constructor(http, eventBus){   
    this.http = http
    this.eventBus = eventBus
    this.praticheUrl = `${services.ask_pratiche.url}`
    this.backendUrl = `${services.ask_backend.url}`
    this.praticheBaseUrl = `${services.ask_pratiche_base.url}`
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }


  async createCsvSwitchIn(value){
    let success = false
    const url = `${this.praticheUrl}/operation/sii/switch-in/massive/csv`
    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        success = true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          success: success
        }    
    }

  }


  async downloadMultipodsPdf(items, max){

    const url = `${this.praticheUrl}/operation/multipods/download/pdf`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {data:items, maxItems: max},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res,  {type: 'application/pdf'})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async uploadMultipodsFile(fileXls, max){
    
    const url = `${this.praticheUrl}/operation/multipods/upload/file`
    let fd = new FormData();
    for (let i = 0 ; i < fileXls.length ; i++) {
      fd.append('files[]', fileXls[i]); 
    }

    fd.append('maxItems', max)

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res,  {type: 'application/pdf'})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async downloadMultipdrsPdf(items, max){

    const url = `${this.praticheUrl}/operation/multipdrs/download/pdf`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {data:items, maxItems: max},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res,  {type: 'application/pdf'})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async uploadMultipdrsFile(fileXls, max){
    
    const url = `${this.praticheUrl}/operation/multipdrs/upload/file`
    let fd = new FormData();
    for (let i = 0 ; i < fileXls.length ; i++) {
      fd.append('files[]', fileXls[i]); 
    }

    fd.append('maxItems', max)

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res,  {type: 'application/pdf'})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async downloadDichiarazioneIva(items, da_iva, ad_iva){

    const url = `${this.praticheUrl}/operation/dichiarazione-iva/download/pdf`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {data:items, da_iva: da_iva, ad_iva: ad_iva},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res,  {type: 'application/pdf'})

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async downloadConsumiDispacciamentoFile(year){

    const url = `${this.praticheUrl}/operation/consumi/dispacciamento/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {data:year},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async uploadInserimentoMassivoFile(file, type){
    let items;
    const url = `${this.praticheUrl}/operation/inserimento-massivo/upload/file`
    let fd = new FormData();
    fd.append('type', type); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {

      let res = 
      await this.http({
          url,
          method: 'POST',
          data: fd,
        })
      this.eventBus.emit('data-load-success', {message: res.data.msg})
      items =  res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }  
    }
  }

  async checkInserimentoFileMassivo(file, preview, type){
    let items;
    let path;
    let url = `${this.praticheUrl}/operation/inserimento-check-massivo/upload/file`
    let fd = new FormData();
    fd.append('preview', preview); 
    fd.append('type', type); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }
    try {
      let res = await this.http({
          url,
          method: 'POST',
          data: fd,
        })
      items = res.data.response
      path =  res.data.url
      this.eventBus.emit('data-load-success', {message: res.data.response.msg})
    } 
    catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } 
    finally {
        this.eventBus.emit('data-loaded');
        // eslint-disable-next-line no-unsafe-finally
        return {
          items, path
        }  
    }
  }

  async downloadMassivo(path){
    let url = `${this.praticheUrl}/operation/inserimento-check-massivo/download/file`
    let fd = new FormData();
    fd.append('url', path); 
    try {
      let res = await this.http({
          url,
          method: 'POST',
          data: fd,
          responseType: 'blob',
        })
      this.filemanager.download(res)
    } catch (error) {
      // Gestione degli errori
      console.error(error);
    // } finally {
    //   this.eventBus.emit('data-loaded');
    }
  }

  async uploadMassivo(){
    let url = `${this.praticheUrl}/operation/inserimento-massivo-from-temptable/upload/file`
    // let fd = new FormData();
    // fd.append('url', path);
    let msg;
    let success;
    try {
      let res = await this.http({
          url,
          method: 'GET',
          // data: fd,
          // responseType: 'blob',
        })

        msg = res.data
        if (msg == 'Errore nel caricamento') {
          success = 'error'
        }else{
          success = 'success'
        }
        this.eventBus.emit('data-load-'+success, {message: msg})
    } catch (error) {
      // Gestione degli errori
      console.error(error);
    // } finally {
    //   this.eventBus.emit('data-loaded');
    }
  }




  async editInvoice(invoice){
    let item = {}
    const url = `${this.praticheUrl}/operation/detail/fattura-vendita/edit`
    try {
        let res = await this.http.post(url, {
          data: invoice
        })
        item = res.data
        // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item
        }    
    }

  }

  async editInvoices(invoices, data_emissione, data_scadenza){
    let item = {}
    const url = `${this.praticheUrl}/operation/fatture-vendita/edit`
    try {
        let res = await this.http.post(url, {
          data: {
            'invoices': invoices,
            'data_emissione': data_emissione,
            'data_scadenza': data_scadenza,
          }
        })
        item = res.data
        // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item
        }    
    }

  }

  async getProspettoConsumi(pods){
    let items = {}
    const url = `${this.praticheUrl}/operation/pods/prospetto/consumi`
    try {
        let res = await this.http.post(url, {
          data: pods
        })
        items = res.data
        // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }


  async createRcuUnicoFile(file){
    
    const url = `${this.praticheUrl}/operation/rcu-unico/file/download`
    let fd = new FormData();
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async createSommarioConsumiFornitoriFile(file){
    
    const url = `${this.praticheUrl}/operation/sommario-consumi-fornitori/file/download`
    let fd = new FormData();
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async getMultiProspettoCicloPagamenti(rappresentanti, year, agenti){
    let items = {}
    const url = `${this.praticheUrl}/operation/rappresentanti/multi/prospetto/ciclo/pagamenti`
    try {
        let res = await this.http.post(url, {
          'rappresentanti':rappresentanti,
          'agenti':agenti,
          'year':year,
        })
        items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }


  async downloadMultiProspettoCicloPagamenti(items, option){

    const url = `${this.praticheUrl}/operation/multiprospetto/pagamenti/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {data:items, option:option},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async invitoAutolettura(file, date){
    let items;
    const url = `${this.praticheUrl}/operation/invito/autolettura`
    let fd = new FormData();
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    fd.append('date', date)

    try {
      let res = 
      await this.http({
          url,
          method: 'POST',
          data: fd,
        })
      this.eventBus.emit('data-load-success', {message: res.data.msg})
      items =  res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded') 
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }  
    }

  }



  async sospendi_riattiva_pods(pods, type){
    let items = {}
    const url = `${this.praticheUrl}/operation/pods/sospensioni-riattivazioni/new`
    try {
        let res = await this.http.post(url, {pods, type})
        items = res.data
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async getPodByState(codTypeState) {
    let items = {};
    let path = this.praticheUrl
    const url = `${path}/operation/pods/pod-by-state?cod_type_state=${codTypeState}`;
    try {
      const res = await this.http.get(url);
      items = res;
      // if (successMessage) this.eventBus.emit('data-load-success', { message: successMessage });
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }
    return items.data;
  }

  // PDR
  async get_sospensione_richiesta_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospensione-richiesta-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Richieste Sospensioni pdr Caricate'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_sospensione_lavorazione_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospensione-lavorazione-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Sospensioni in Lavorazione pdr caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_sospesi() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni/get-sospesi-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr sospesi caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_riattivazione_richiesta_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivazione-richiesta-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Richieste Riattivazione pdr Caricate'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_riattivazione_lavorazione_pdr() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivazione-lavorazione-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Riattivazioni in lavorazione pdr caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_riattivati() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riattivati-pdr`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_sosp_ko() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-sosp-ko`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  async get_pdr_riat_ko() {
    let items = {};
    const url = `${this.praticheUrl}/operation/pdrs/riattivazione/get-riat-ko`;
    try {
      let res = await this.http.get(url);
      items = res;
      // this.eventBus.emit('data-load-success', {message: 'Pdr riattivati caricati'})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
    return items.data;
  }

  get_file_date() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 0-11
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDate = `${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
    return formattedDate;
  }

  async generazioneCsvSospensioniRiattivazioniPod(podIds = [], type = 'sospensioni', cambiaStato = true) {
    const url = `${this.praticheUrl}/operation/pods/sospensioni-riattivazioni/genera-csv`;
    const formattedDate = this.get_file_date();

    try {
        const response = await this.http.post(url, { podIds, type, cambiaStato }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        // const blob = new Blob([response.data], { type: 'application/zip' });
        const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = urlObject;
        // link.setAttribute('download', `${type}_richieste_pod.zip`);
        link.setAttribute('download', `${type}_richieste_pod_${formattedDate}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async generazioneCsvSospensioniRiattivazioniPdr(pdrIds = [], type = 'sospensioni') {
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni-riattivazioni/genera-csv`;
    const formattedDate = this.get_file_date();

    try {
        const response = await this.http.post(url, { pdrIds, type }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        const blob = new Blob([response.data], { type: 'application/zip' });
        // const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = urlObject;
        link.setAttribute('download', `${type}_richieste_pdr_${formattedDate}.zip`);
        // link.setAttribute('download', `${type}_richieste_pod.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async sospendi_riattiva_pdrs(pdrs, type){
    let items = {}
    const url = `${this.praticheUrl}/operation/pdrs/sospensioni-riattivazioni`
    try {
        let res = await this.http.post(url, {pdrs, type})
        items = res.data
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }


  async createPreSuspensionOrReactivation(obj){
    let items = {}
    const url = `${this.praticheUrl}/operation/preview/sospensioni-riattivazioni`
    try {
        let res = await this.http.post(url, obj)
        items = res.data
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async createMultiPreSuspensionOrReactivation(items, typeFornitura, typePratica){
    const url = `${this.praticheUrl}/operation/preview/multi/sospensioni-riattivazioni`
    try {
        let res = await this.http.post(url, {items, typeFornitura, typePratica})
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')  
    }
  }

  async setInSouspensionOrReactivation(objs){
    let items = {}
    const url = `${this.praticheUrl}/set/sospensioni-riattivazioni`
    try {
        let res = await this.http.post(url, {items:objs})
        items = res.data
        // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async deletePreviewSouspensionOrReactivation(objs){
    let items = {}
    const url = `${this.praticheUrl}/preview/sospensioni-riattivazioni/delete`
    try {
        let res = await this.http.post(url, {items:objs})
        items = res.data
        if (res.data.success) {
          this.eventBus.emit('data-load-success', {message: res.data.msg})
        } else {
          this.eventBus.emit('data-load-error', {message: res.data.msg})
        }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }

  async previewRilascioTutela(items, typeFornitura){
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/rilascio-tutela-preview`;

    try {
        let res = await this.http.post(url, {items, typeFornitura})
        this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')  
    }
  }

  async deletePreviewRilascioTutela(objs) {
    let items = {};
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/delete-tutela-preview`;

    try {
        let res = await this.http.post(url, {items:objs})
        items = res.data
        if (res.data.success) {
          this.eventBus.emit('data-load-success', {message: res.data.msg})
        } else {
          this.eventBus.emit('data-load-error', {message: res.data.msg})
        }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }
    return { items };
  }

  async setRilascioTutela(objs) { // TODO
    let items = {};
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/richiesta-tutela`;
    try {
        let res = await this.http.post(url, {items:objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }
    return { items };
  }

  async getStatoTutelaFornitura(tipoFornitura, stato, page = 1, perPage = 30, sortField = null, sortOrder = null) {
    let items = {};
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/get-stato`;

    try {
      const res = await this.http.post(url, {
        tipo: tipoFornitura,
        stato: stato,
        page: page,
        per_page: perPage,
        sort_field: sortField,
        sort_order: sortOrder === 1 ? 'asc' : (sortOrder === -1 ? 'desc' : null)
      });
      items = res;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items.data;
  }

  async searchStatoTutelaFornitura(tipoFornitura, stato, search) {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/search-stato`;

    try {
        const res = await this.http.post(url, {
            tipo: tipoFornitura,
            stato: stato,
            search: search
        });
        return res.data;
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err, url });
        return null;
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async geTipiStatoFornituraTutela() {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/get-stati-tutela`;

    try {
      const res = await this.http.get(url);
      return res.data.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return [];
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async getTutelaHistory(pods, pdrs) {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/history`;

    try {
      const res = await this.http.get(url, { params: { pods, pdrs } });
      return res.data.data;
    } catch (err) {
      this.eventBus.emit("data-load-error", { message: err, url });
      return [];
    } finally {
      this.eventBus.emit("data-loaded");
    }
  }

  async cambiaStatoTutelaPodPdr(pods, pdrs, stato) {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/cambia-stati-tutela`;

    try {
        let res = await this.http.post(url, { pods, pdrs, stato });
        this.eventBus.emit('data-load-success', {message: res.data.message});
        return res;
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url});
    }
  }

  async generazioneCsvTutela(tipoFornitura, forniture = []) {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/download-csv`;

    try {
        const response = await this.http.post(url, { tipoFornitura, forniture }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        const suffix = tipoFornitura.toUpperCase() === 'POD' ? 'RC1' : 'RCG1';
        const filename = `${timestamp}_${suffix}.csv`;

        const link = document.createElement('a');
        link.href = urlObject;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

  async generazioneCsvTutelaTutti(tipoFornitura) {
    const url = `${this.praticheBaseUrl}/api/forniture-tutela/download-tutti-csv`;

    try {
        const response = await this.http.post(url, { tipoFornitura }, { responseType: 'blob' });

        if (response.status !== 200) {
            throw new Error('Errore durante la generazione del CSV');
        }

        const blob = new Blob([response.data], { type: 'text/csv' });
        const urlObject = window.URL.createObjectURL(blob);

        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
        const suffix = tipoFornitura.toUpperCase() === 'POD' ? 'RC1' : 'RCG1';
        const filename = `${timestamp}_${suffix}.csv`;

        const link = document.createElement('a');
        link.href = urlObject;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.eventBus.emit('data-load-success', { message: 'File CSV generato e scaricato con successo' });

        return 'ok';
    } catch (err) {
        this.eventBus.emit('data-load-error', { message: err.message, url });
        console.error('Errore durante la generazione o il download del file CSV:', err);
    } finally {
        this.eventBus.emit('data-loaded');
    }
  }

    async updateDataDecorrenzaTutela(id, tipoFornitura, dataDecorrenza) {
      const url = `${this.praticheBaseUrl}/api/forniture-tutela/update-data-decorrenza`;

      try {
        const res = await this.http.post(url, {
          id,
          tipo: tipoFornitura,
          data_decorrenza: dataDecorrenza,
        });

        if (res.data?.message) {
          this.eventBus.emit('data-load-success', { message: res.data.message });
        }

        return res.data;
      } catch (err) {
        this.eventBus.emit('data-load-error', { message: err, url });
        return null;
      } finally {
        this.eventBus.emit('data-loaded');
      }
    }

    async resetDataDecorrenzaTutela(id, tipoFornitura) {
      const url = `${this.praticheBaseUrl}/api/forniture-tutela/reset-data-decorrenza`;

      try {
        const res = await this.http.post(url, {
          id,
          tipo: tipoFornitura,
        });

        if (res.data?.message) {
          this.eventBus.emit('data-load-success', { message: res.data.message });
        }

        return res.data;
      } catch (err) {
        this.eventBus.emit('data-load-error', { message: err, url });
        return null;
      } finally {
        this.eventBus.emit('data-loaded');
      }
    }

  async downloadExportDAR(dates, agentsToExclude, agentsToApart){

    const url = `${this.praticheUrl}/operation/export-dar/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {dates, agentsToExclude, agentsToApart},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async getModulisticaGlobale(){
    let items = {}

    const url = `${this.praticheUrl}/operation/agenti/modulistica/globale`
    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async uploadModulisticaGlobale(file, idAgente, isGlobal){
    
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.apiUrl}/clienti/agenti/modulo/upload`
    let fd = new FormData();
    fd.append('title', file.title);
    fd.append('isGlobal', isGlobal);
    fd.append('idAgente', idAgente);
    for (let i = 0 ; i < file.file.length ; i++) {
      fd.append('files[]', file.file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)
      this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }

  }


  async downloadPdfFattureVenditaQuietanza(objs){
    const url = `${this.praticheUrl}/operation/fatture-vendita/quietanza/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {objs},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async getFornitureInSospensioneSaldate(type_fornitura){
    let items = {}
    const url = `${this.praticheUrl}/forniture/sospese/saldate/${type_fornitura}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }


  async sendFattureVenditaByEmail(objs){
    let items = {}
    const url = `${this.apiUrl}/clienti/fatture/invio/email`
    try {
        let res = await this.http.post(url, {objs})
        items = res.data
    } catch (err) {
        console.error('Errore in sendFattureVenditaByEmail:', err)
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }    
    }

  }


  async checkSddXml(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.praticheUrl}/rids/sdd/check/flusso/xml`
    let fd = new FormData();
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        } 
    }

  }


  async importCompensazioniFile(fileXls){
    let items = {}
    const url = `${this.praticheUrl}/operation/compensazioni/import/file`
    let fd = new FormData();
    for (let i = 0 ; i < fileXls.length ; i++) {
      fd.append('file[]', fileXls[i]); 
    }

    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
          })
        //this.eventBus.emit('data-load-success', {message: res.data})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items
        }  
    }

  }

  async getAllTipoClient(){
    let items = {}
    const url = `${this.praticheUrl}/get-tipo-cliente`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  

  async getTypeState() {
    const url = `${this.praticheUrl}/get-stati`;

    try {
        let res = await this.http.get(url);
        return res.data;
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url});
    }
  }

}
